var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-skeletons" },
    _vm._l(_vm.skeletons, function (skeleton) {
      return _c(
        "div",
        { key: skeleton, staticClass: "message-skeleton" },
        [
          _c("a-skeleton", {
            staticStyle: { "z-index": "9" },
            attrs: { active: "", avatar: "", paragraph: { rows: 4 } },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }